import { getAccessToken, clearTokens } from "@/contexts/AuthContext";
import { API_BASE_URL } from "@/config/env";
import { refreshAccessToken } from "@/lib/auth/admin-auth-client";
import { createApiClient } from "@atsready/shared/utils";
import type { ApiClient } from "@atsready/shared/utils";

export { API_BASE_URL };

// ============================================================================
// Shared client instance — wired to admin-specific auth
// ============================================================================

const _client: ApiClient = createApiClient({
  baseUrl: `${API_BASE_URL}/v1/admin`,
  getToken: () => getAccessToken(),
  // T15: a 401 tries one shared single-flight refresh, then retries the request once.
  refreshToken: refreshAccessToken,
  clearSession: () => clearTokens(),
  onAuthFailure: () => {
    window.location.href = "/login";
  },
});

export async function request<T>(endpoint: string, options?: RequestInit): Promise<T> {
  return _client.request<T>(endpoint, options);
}
